"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekdayButtonArgs = exports.WeekdayButton = exports.TodayButtonArgs = exports.TodayButton = exports.TimeOffButtonArgs = exports.TimeOffButton = exports.TextButtonArgs = exports.TextButton = exports.RightButtonArgs = exports.RightButton = exports.RescheduleButtonArgs = exports.RescheduleButton = exports.RescheduleAllButtonArgs = exports.RescheduleAllButton = exports.ManageOverdueButtonArgs = exports.ManageOverdueButton = exports.LeftButtonArgs = exports.LeftButton = exports.IconTileButtonArgs = exports.IconTileButton = exports.FiltersButtonArgs = exports.FiltersButton = exports.ContainedButtonArgs = exports.ContainedButton = exports.CircleButtonArgs = exports.CircleButton = exports.CalendarButton = exports.CalendarActionsButtonArgs = exports.CalendarActionsButton = exports.AddEventButtonArgs = exports.AddEventButton = void 0;
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var il_button_1 = require("./il-button");
var icons_1 = require("../../shared/icons");
// arguments
var ContainedButtonArgs = {
    children: 'Next',
    variant: enums_1.ButtonVariantEnum.CONTAINED,
    sx: {
        borderRadius: '1.5rem',
        width: '12.5rem', // 200px
    },
};
exports.ContainedButtonArgs = ContainedButtonArgs;
var TextButtonArgs = {
    children: 'Back',
    sx: {
        fontSize: '16px',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: 'transparent',
            color: 'action.hover',
        },
    },
    variant: enums_1.ButtonVariantEnum.TEXT,
};
exports.TextButtonArgs = TextButtonArgs;
var CircleButtonArgs = {
    children: 1,
    variant: enums_1.ButtonVariantEnum.OUTLINED,
    sx: {
        fontSize: '1.5em',
        width: '3em',
        height: '3em',
        borderRadius: '25em',
        color: 'action.disabled',
        backgroundColor: 'background.default',
        borderColor: 'action.disabledBackground',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: 'background.default',
            borderColor: 'action.disabled',
            boxShadow: 'none',
        },
        '&.active, &:active, &.Mui-selected': {
            color: 'primary.contrastText',
            backgroundColor: 'primary.main',
            borderColor: '#087194',
            '&:hover': {
                backgroundColor: 'primary.main',
            },
        },
    },
};
exports.CircleButtonArgs = CircleButtonArgs;
var WeekdayButtonArgs = {
    children: 'M',
    variant: enums_1.ButtonVariantEnum.CONTAINED,
    disabled: true,
    sx: {
        color: 'action.disabled',
        backgroundColor: 'background.paper',
        minWidth: '1rem',
        width: '1rem',
        height: '1rem',
        margin: '0.0625rem',
        padding: '0',
        boxShadow: 'none',
        fontFamily: 'Open Sans',
        fontSize: '0.75rem',
        fontWeight: 'normal',
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        border: 'none',
        borderRadius: '0.125rem',
        '&:disabled': {
            backgroundColor: 'background.paper',
        },
        '&:hover': {
            backgroundColor: 'background.paper',
            borderColor: 'background.paper',
            boxShadow: 'none',
        },
        '&.active, &:active, &.Mui-selected': {
            fontWeight: 'bold',
            color: 'primary.contrastText',
            backgroundColor: 'primary.main',
        },
    },
};
exports.WeekdayButtonArgs = WeekdayButtonArgs;
var IconTileButtonArgs = {
    children: 1,
    variant: enums_1.ButtonVariantEnum.TEXT,
    sx: {
        m: 1,
        borderRadius: '1rem',
        width: '9.75rem',
        height: '9.75rem',
        backgroundColor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        boxShadow: 3,
        position: 'relative',
        fontSize: '18px',
        fontWeight: '600',
        lineHeight: 1.33,
        textAlign: 'center',
        mt: 1.5,
        color: 'primary.dark',
        borderColor: 'action.disabledBackground',
        '&:hover': {
            backgroundColor: 'background.default',
            boxShadow: 'none',
            borderColor: 'primary.dark',
            borderWidth: '1px',
            borderStyle: 'solid',
        },
        '&.active, &:active, &.Mui-selected': {
            borderColor: 'primary.dark',
            borderWidth: '4px',
            borderStyle: 'solid',
            '&:hover': {
                backgroundColor: 'primary.main',
            },
        },
    },
};
exports.IconTileButtonArgs = IconTileButtonArgs;
var calendarIconActionSx = {
    color: 'text.disabled',
};
var TodayButtonArgs = {
    children: 'Today',
    startIcon: react_1.default.createElement(icons_1.TodaySvgIcon, { sx: __assign({}, calendarIconActionSx) }),
    sx: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        borderWidth: '.125rem', // 2px
        borderStyle: 'solid',
        boxShadow: 'none',
        maxHeight: '2rem',
        fontSize: '0.8125rem', // 13px
        color: 'text.primary',
        fontWeight: 'normal',
        '&:hover': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            borderColor: 'text.disabled',
        },
    },
    variant: enums_1.ButtonVariantEnum.CONTAINED,
};
exports.TodayButtonArgs = TodayButtonArgs;
var basePlannerActionButtonArgs = {
    variant: enums_1.ButtonVariantEnum.CONTAINED,
    sx: {
        boxShadow: 'none',
        borderRadius: '1.5rem', // 24px
        borderWidth: '0px',
        backgroundColor: 'transparent',
        maxHeight: '2rem', // 32px
        fontSize: '0.8125rem', // 13px
        fontWeight: 600,
        color: 'text.primary',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: 'background.paper',
        },
    },
};
var RescheduleButtonArgs = __assign(__assign({}, basePlannerActionButtonArgs), { children: 'Reschedule', startIcon: react_1.default.createElement(icons_1.RescheduleSvgIcon, { sx: __assign({}, calendarIconActionSx) }) });
exports.RescheduleButtonArgs = RescheduleButtonArgs;
var AddEventButtonArgs = __assign(__assign({}, basePlannerActionButtonArgs), { children: 'Add', startIcon: react_1.default.createElement(icons_1.AddEventSvgIcon, { sx: __assign({}, calendarIconActionSx) }) });
exports.AddEventButtonArgs = AddEventButtonArgs;
var TimeOffButtonArgs = __assign(__assign({}, basePlannerActionButtonArgs), { children: 'Time Off', startIcon: react_1.default.createElement(icons_1.TimeOffSvgIcon, { sx: __assign({}, calendarIconActionSx) }) });
exports.TimeOffButtonArgs = TimeOffButtonArgs;
var iconButtonProps = {
    variant: enums_1.ButtonVariantEnum.TEXT,
    sx: {
        color: 'text.primary',
        fontWeight: 'normal',
        '&:hover': {
            backgroundColor: 'transparent',
            color: 'action.hover',
        },
    },
};
var LeftButtonArgs = __assign(__assign({}, iconButtonProps), { children: react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_LEFT, size: enums_1.IconSizeEnum.LARGE }), sx: __assign(__assign({}, iconButtonProps.sx), { maxHeight: '2rem', maxWidth: '2rem', minWidth: '2rem' }) });
exports.LeftButtonArgs = LeftButtonArgs;
var RightButtonArgs = __assign(__assign({}, iconButtonProps), { children: react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CHEVRON_RIGHT, size: enums_1.IconSizeEnum.LARGE }), sx: __assign(__assign({}, iconButtonProps.sx), { maxHeight: '2rem', maxWidth: '2rem', minWidth: '2rem' }) });
exports.RightButtonArgs = RightButtonArgs;
var FiltersButtonArgs = __assign(__assign({}, iconButtonProps), { startIcon: react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.BARS_FILTER, size: enums_1.IconSizeEnum.SMALL }), children: 'Filters' });
exports.FiltersButtonArgs = FiltersButtonArgs;
var CalendarActionsButtonArgs = __assign(__assign({}, iconButtonProps), { startIcon: react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.ELLIPSIS, size: enums_1.IconSizeEnum.SMALL }), children: 'Calendar Actions' });
exports.CalendarActionsButtonArgs = CalendarActionsButtonArgs;
var chipButtonSx = {
    px: '1rem',
    borderWidth: '0.05rem',
    borderStyle: 'solid',
    borderColor: 'grey.300',
    borderRadius: '1rem',
    maxHeight: '2rem',
    backgroundColor: 'background.default',
    fontSize: { xs: '0.875rem', sm: '1rem' },
    color: 'text.primary',
    fontWeight: '500',
    '&:hover': {
        borderColor: 'action.hover',
        backgroundColor: 'background.default',
    },
};
var ManageOverdueButtonArgs = {
    children: 'Manage Overdue',
    sx: chipButtonSx,
    variant: enums_1.ButtonVariantEnum.TEXT,
};
exports.ManageOverdueButtonArgs = ManageOverdueButtonArgs;
var RescheduleAllButtonArgs = {
    children: 'Reschedule All',
    sx: __assign(__assign({}, chipButtonSx), { '& .MuiButton-startIcon': {
            transform: 'scaleX(-1)',
        } }),
    variant: enums_1.ButtonVariantEnum.TEXT,
    startIcon: (react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.CLOCK_ROTATE_LEFT, size: enums_1.IconSizeEnum.SMALL, sx: { color: 'text.secondary' } })),
};
exports.RescheduleAllButtonArgs = RescheduleAllButtonArgs;
// components
var ContainedButton = (0, get_component_1.getComponent)(il_button_1.ILButton, ContainedButtonArgs);
exports.ContainedButton = ContainedButton;
var TextButton = (0, get_component_1.getComponent)(il_button_1.ILButton, TextButtonArgs);
exports.TextButton = TextButton;
var CircleButton = (0, get_component_1.getComponent)(il_button_1.ILButton, CircleButtonArgs);
exports.CircleButton = CircleButton;
var IconTileButton = (0, get_component_1.getComponent)(il_button_1.ILButton, IconTileButtonArgs);
exports.IconTileButton = IconTileButton;
var CalendarButton = (0, get_component_1.getComponent)(il_button_1.ILButton, TodayButtonArgs);
exports.CalendarButton = CalendarButton;
var WeekdayButton = (0, get_component_1.getComponent)(il_button_1.ILButton, WeekdayButtonArgs);
exports.WeekdayButton = WeekdayButton;
var RescheduleButton = (0, get_component_1.getComponent)(il_button_1.ILButton, RescheduleButtonArgs);
exports.RescheduleButton = RescheduleButton;
var AddEventButton = (0, get_component_1.getComponent)(il_button_1.ILButton, AddEventButtonArgs);
exports.AddEventButton = AddEventButton;
var TimeOffButton = (0, get_component_1.getComponent)(il_button_1.ILButton, TimeOffButtonArgs);
exports.TimeOffButton = TimeOffButton;
var TodayButton = (0, get_component_1.getComponent)(il_button_1.ILButton, TodayButtonArgs);
exports.TodayButton = TodayButton;
var FiltersButton = (0, get_component_1.getComponent)(il_button_1.ILButton, FiltersButtonArgs);
exports.FiltersButton = FiltersButton;
var CalendarActionsButton = (0, get_component_1.getComponent)(il_button_1.ILButton, CalendarActionsButtonArgs);
exports.CalendarActionsButton = CalendarActionsButton;
var LeftButton = (0, get_component_1.getComponent)(il_button_1.ILButton, LeftButtonArgs);
exports.LeftButton = LeftButton;
var RightButton = (0, get_component_1.getComponent)(il_button_1.ILButton, RightButtonArgs);
exports.RightButton = RightButton;
var RescheduleAllButton = (0, get_component_1.getComponent)(il_button_1.ILButton, RescheduleAllButtonArgs);
exports.RescheduleAllButton = RescheduleAllButton;
var ManageOverdueButton = (0, get_component_1.getComponent)(il_button_1.ILButton, ManageOverdueButtonArgs);
exports.ManageOverdueButton = ManageOverdueButton;
